import React from 'react';
import { PATHS } from '@/routes/paths';
import { useSession } from '@/hooks/useSession';
import { useHasSimulados } from './use-has-simulados';
import { greetingForDay, DottedTrail } from './hero-welcome';
import { HeroLevelCard } from './hero-level-card';
import { HeroDecorations } from './hero-decorations';
import { HeroContinue } from './hero-continue';
import { HomeNavCard } from './home-nav-card';
import { HomeWelcomeVideoModal } from './home-welcome-video-modal';
import { TiaBanner } from '@/components/custom/tia-banner';
import tiaBoasVindas from '@/assets/images/tia/TIA-BOAS-VINDAS.png';
import books3d from '@/assets/images/icons/books-3d.png';
import rocket3d from '@/assets/images/icons/rocket-3d.png';
import trophy3d from '@/assets/images/icons/trophy-3d.png';

// Tints pastéis dos nav-cards (bg do card + cor do botão de seta).
const NAV_ACCENTS = {
  trilha: { bg: 'var(--color-bg-teal)', arrow: 'var(--color-third)' },
  simulado: { bg: 'var(--color-bg-lilac-soft)', arrow: 'var(--color-secondary)' },
  conquistas: { bg: 'var(--color-bg-amber-soft)', arrow: 'var(--color-mission-medium)' }
};

const WELCOME_TIA_DECORATION = (
  <>
    <DottedTrail />
    <span
      aria-hidden="true"
      className="pointer-events-none absolute right-5 top-2 text-xl"
    >
      ⭐
    </span>
    <span
      aria-hidden="true"
      className="pointer-events-none absolute right-12 top-6 text-lg"
      style={{ transform: 'rotate(-20deg)' }}
    >
      ✈️
    </span>
  </>
);

export function DashboardHomeHeroB({ videoId }) {
  const hasSimulados = useHasSimulados();
  const { session } = useSession();
  const userId = session?.user?.id;
  const firstName = (session?.user?.name || '').trim().split(' ')[0];
  const welcomeMessage = greetingForDay(new Date().getDay(), firstName);

  return (
    <div className="relative mb-6 flex flex-col gap-6">
      {/* Decorações de fundo — absolutas, atrás de tudo */}
      <HeroDecorations />

      {/* 1. Linha de topo: boas-vindas (flex-1) + card de nível (~320px).
          mt dá espaço pra cabeça da T.I.A (~41px acima do card) estourar pra cima
          sem ir parar atrás do header fixo (opaco, z-104); no mobile 48px bastam. */}
      <div className="relative mt-12 flex flex-col gap-4 sm:mt-24 sm:flex-row sm:items-stretch">
        <div className="flex-1">
          <TiaBanner
            className="h-full"
            image={tiaBoasVindas}
            imageHeight={215}
            imageOffset={200}
            bubbleCorner="tl"
            bubbleMaxWidth={400}
            text={welcomeMessage}
            decoration={WELCOME_TIA_DECORATION}
          />
        </div>
        <div className="sm:w-[320px] sm:shrink-0">
          <HeroLevelCard />
        </div>
      </div>

      {/* 2. Hero grande "Continuar" */}
      <div className="relative">
        <HeroContinue />
      </div>

      {/* 3. Linha de 3 nav-cards — ilustração em destaque, texto curto */}
      <div className="relative grid grid-cols-1 gap-4 sm:grid-cols-3">
        <HomeNavCard
          to={PATHS.LEARNING_PATH.ROOT}
          illustration={books3d}
          title="Minha Trilha"
          subtitle="Seu próximo passo"
          accent={NAV_ACCENTS.trilha}
        />
        <HomeNavCard
          to={hasSimulados ? PATHS.EXAM.MOCK_LIST : undefined}
          illustration={rocket3d}
          title="Simulado"
          subtitle="Treino SAEB"
          accent={NAV_ACCENTS.simulado}
          comingSoon={!hasSimulados}
        />
        <HomeNavCard
          to={PATHS.PROFILE.USER('medalhas', userId)}
          illustration={trophy3d}
          title="Conquistas"
          subtitle="Seus troféus"
          accent={NAV_ACCENTS.conquistas}
        />
      </div>

      {/* 4. Modal de boas-vindas com o vídeo da semana (abre sozinha se houver vídeo) */}
      <HomeWelcomeVideoModal videoId={videoId} />
    </div>
  );
}
